import { render, staticRenderFns } from "./VideoInlineScroll.vue?vue&type=template&id=b90ac5b8&"
import script from "./VideoInlineScroll.vue?vue&type=script&lang=js&"
export * from "./VideoInlineScroll.vue?vue&type=script&lang=js&"
import style0 from "./VideoInlineScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports